import React, { PureComponent } from "react";
import { Card, Col, Row, Container, ModalHeader, Button } from "reactstrap";
import RequestManager from "../../singletons/RequestManager";
export default class SOSWaiter extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      orderModalVisible: false,
      SOSWaiters: null,
      forRegions: null
    };
  }

  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible
    });
  };
  componentDidMount() {
    this.setState({
      SOSWaiters: this.props.SOSWaiters,
      forRegions: this.state.SOSForRegions
    });
  }

  render() {
    return (
      <div>
        <ModalHeader toggle={this.props.goBack}>
          <p>Services </p>
        </ModalHeader>
        {this.state.SOSWaiters &&
          this.state.SOSWaiters.edges.map(sos => {
            return (
              <Container fluid style={{ padding: 0 }}>
                <Card
                  className={"p-0"}
                  style={{
                    display: "flex",
                    margin: 10,
                    color: "black"
                  }}
                >
                  <Row>
                    <Col xs="12"></Col>
                  </Row>
                  <Row noGutters style={{ alignItems: "center" }}>
                    <div
                      style={{
                        display: "flex",
                        height: "100%",
                        flexDirection: "column",
                        padding: 10,
                        justifyContent: "center"
                      }}
                    >
                      {sos.node.location !== null ? (
                        <p style={{ margin: 0, padding: 0 }}>
                          {"Table Number : " + sos.node.location}
                        </p>
                      ) : (
                        <p style={{ margin: 0, padding: 0 }}>
                          {"Table Number : "}
                        </p>
                      )}
                      {
                        // <p style={{ margin: 0, padding: 0 }}>
                        //   {"Cus Phone No : " + sos.node.user.phone}{" "}
                        // </p>
                        // <p style={{ margin: 0, padding: 0 }}>
                        //   {"Cus Name : " +
                        //     sos.node.user.userProfile.firstName +
                        //     " " +
                        //     sos.node.user.userProfile.lastName}{" "}
                        // </p>
                      }
                      <p style={{ margin: 0, padding: 0 }}>
                        {"Service : " + sos.node.service.name}{" "}
                      </p>
                      {
                        // {sos.node.comments !== null ? (
                        //   <p style={{ margin: 0, padding: 0 }}>
                        //     {"Comments:" + sos.node.comments}{" "}
                        //   </p>
                        // ) : null}
                      }
                    </div>
                    <Col
                      xs="12"
                      style={{
                        margin: 10,
                        display: "flex",
                        flex: 1,
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center"
                      }}
                    >
                      <p></p>
                      {
                        // <Button
                        //   color={"primary"}
                        //   disabled={sos.node.isAccepted === false ? false : true}
                        //   onClick={() => {
                        //     this.updateSOSWaiter(sos.node.id, false, true);
                        //   }}
                        // >
                        //   Accepted
                        // </Button>
                      }
                      <Button
                        color={"success"}
                        disabled={sos.node.isFulfilled === false ? false : true}
                        onClick={() => {
                          this.updateSOSWaiter(sos.node.id, true, true);
                        }}
                      >
                        Ok
                      </Button>
                    </Col>
                  </Row>
                </Card>
              </Container>
            );
          })}
      </div>
    );
  }

  getuserAvailedServices = async () => {
    let requestManager = new RequestManager();
    let params = {
      forRegions: this.state.forRegions
    };
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getuserAvailedServices",
      params
    );
    // console.log("getuserAvailedServices", JSON.stringify(response));
    if (response.error) {
      // alert('Something went wrong. Please try again later.')
    } else {
      let SOSWaiters = response.data.userAvailedServices;

      this.setState({ SOSWaiters: SOSWaiters });
    }
  };

  updateSOSWaiter = async (serviceId, checkIsFullfilled, value) => {
    let requestManager = new RequestManager();
    let params;
    if (checkIsFullfilled) {
      params = {
        input: {
          id: serviceId,
          isFulfilled: value
        }
      };
    } else {
      params = {
        input: {
          id: serviceId,
          isAccepted: value
        }
      };
    }

    let response = await requestManager.getResponseFromPredefinedQuery(
      "updateSOSWaiter",
      params
    );

    if (response.error === null) {
      this.getuserAvailedServices();
    } else {
      alert(
        "Unable to update Store Status. Please check your internet connection."
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/components/SOSWaiter/SOSWaiter.js